import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-schild-gemeente-utrecht',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconSchildGemeenteUtrecht {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M2 0v23.63c0 2.6.8 5.07 2.17 6.56s2.4 2.6 4.57 3.71c1.83.87 4.46 2.1 9.14 2.1s7.31-1.11 9.14-2.1c1.94-.99 2.97-1.98 4-2.97 1.71-1.61 2.97-4.33 2.97-7.3V0zm30 23c0 3-1.57 5.66-3 7L4 2h28z"/>
</svg>

    );
  }
}
